import Icon from '@ant-design/icons'
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon'
import { forwardRef } from 'react'
import { AntdCustomIconComponentProps } from '../typings/AntdCustomIconComponentProps'

const LockSvg = (props: AntdCustomIconComponentProps) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.725 13.1708C20.725 11.1875 19.4481 9.49753 17.673 8.87966V7.30301C17.673 4.38001 15.295 2.00201 12.375 2.00201C10.954 1.96401 9.626 2.54101 8.62 3.53801C7.615 4.53401 7.058 5.86301 7.052 7.30301V8.87966C5.2769 9.49753 4 11.1875 4 13.1708V17.4598C4 19.9648 6.037 22.0018 8.542 22.0018H16.183C18.688 22.0018 20.725 19.9648 20.725 17.4598V13.1708ZM16.173 7.30301V8.62878H8.552V7.28601C8.556 6.27001 8.955 5.31701 9.677 4.60301C10.394 3.89201 11.343 3.50201 12.356 3.50201H12.372C14.468 3.50201 16.173 5.20701 16.173 7.30301ZM8.542 10.1288C6.864 10.1288 5.5 11.4928 5.5 13.1708V17.4598C5.5 19.1378 6.864 20.5018 8.542 20.5018H16.183C17.86 20.5018 19.225 19.1378 19.225 17.4598V13.1708C19.225 11.4928 17.86 10.1288 16.183 10.1288H8.542ZM11.6123 16.4256C11.6123 16.8396 11.9483 17.1756 12.3623 17.1756C12.7763 17.1756 13.1123 16.8396 13.1123 16.4256V14.2046C13.1123 13.7906 12.7763 13.4546 12.3623 13.4546C11.9483 13.4546 11.6123 13.7906 11.6123 14.2046V16.4256Z"
    />
  </svg>
)

export const Lock = forwardRef<HTMLSpanElement, AntdIconProps>((props, ref) => (
  <Icon component={LockSvg} {...props} ref={ref} />
))
